import { Outlet, useNavigate } from 'react-router-dom';

// project-imports
import Drawer from './Drawer';
import Footer from './Footer';
import Header from './Header';
import Breadcrumbs from 'components/Breadcrumbs';
import NavigationScroll from 'components/NavigationScroll';
import { useSelector } from 'react-redux';
import { useEffect } from 'react';
import { setAuthorizationHeaders } from '../../api/config';

// ==============================|| MAIN LAYOUT ||============================== //

export default function MainLayout() {
  const navigate = useNavigate();
  const accessToken = useSelector((state) => state.reduxState.accessToken);

  useEffect(() => {
    if (accessToken) setAuthorizationHeaders(accessToken);
  }, [accessToken]);

  useEffect(() => {
    if (!accessToken) {
      console.log('token not FOund MainLayout logout');
      navigate('/login');
    }
  }, []);

  return (
    <>
      <Drawer />
      <Header />
      <div className="pc-container">
        <div className="pc-content">
          <Breadcrumbs />
          <NavigationScroll>
            <Outlet />
          </NavigationScroll>
        </div>
      </div>
      <Footer />
    </>
  );
}
